import React from "react";
import Button from "../Button/Button";
import spotGroupIcon from "../../assets/icons/spot-group.svg";
import companyIcon from "../../assets/icons/company.svg";
import standIcon from "../../assets/icons/stand.svg";
import useFunction from "../../hooks/useFunction";
import PropTypes from "prop-types";
// import "./style.scss"


const BookingBookableProfileLinks = ({booking, buttonSize = 's'}) => {

  const { truncate } = useFunction();

  return (
    <div className="component-booing-bookable-profile-links">
      {booking.spot_group ? (
        <>
          <p className="label">Locatie:</p>
          <Button
            color="grey-ghost"
            size={buttonSize}
            link={`/locatie/${booking.spot_group.slug}`}
            label={truncate(booking.spot_group.label, 20)}
            target="_blank"
            icon={spotGroupIcon}
          />
        </>
      ) : booking.type === "spot-group-requests-stand" && booking.requested_by_company ? (
        <>
          <p className="label">Account/organisatie (en geen locatie-profiel):</p>
          <Button
            color="grey-ghost"
            size={buttonSize}
            link={`/user/berichten/${booking.requested_by_company_id}`}
            label={truncate(booking.requested_by_company.legal_name, 20)}
            target="_blank"
            icon={companyIcon}
          />
        </>
      ) : (
        <>Geen locatie</>
      )}

      <p className="label">Stand:</p>
      {booking.stand ? (
        <Button
          color="grey-ghost"
          size={buttonSize}
          link={`/stand/${booking.stand.slug}`}
          label={truncate(booking.stand.label, 20)}
          target="_blank"
          icon={standIcon}
        />
      ) : (
        <>Nog geen stand</>
      )}
    </div>
  )
}


BookingBookableProfileLinks.propTypes = {
  booking: PropTypes.object.isRequired,
  buttonSize: PropTypes.string
}

export default BookingBookableProfileLinks;